import { resolveImageUrl } from './image';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://staging.13.204.65.150.nip.io/api/v1';

const BACKEND_URL = API_BASE_URL.replace('/api/v1', '');

export const getShowcaseImageUrl = (url: string): string => {
  return resolveImageUrl(url);
};
